import type { StatusCategoryKeys } from '@atlassian/jira-common-constants/src/status-categories';
import type { ChangeEvent } from '@atlassian/jira-issue-view-model/src/change-type';
import type { CardId } from '../../../model/types';

export const CARD_STATUS_SET = 'state.actions.status.CARD_STATUS_SET' as const;

export type CardStatusSetAction = {
	type: typeof CARD_STATUS_SET;
	payload: {
		cardId: CardId;
		prevStatusId: string;
		statusId: string;
		statusCategory: StatusCategoryKeys;
		isCMP: boolean;
	};
};

export const cardStatusSet = (
	cardId: CardId,
	prevStatusId: string,
	statusId: string,
	statusCategory: StatusCategoryKeys,
	isCMP: boolean,
): CardStatusSetAction => ({
	type: CARD_STATUS_SET,
	payload: {
		cardId,
		prevStatusId,
		statusId,
		statusCategory,
		isCMP,
	},
});

export const CARD_STATUS_CHECK = 'state.actions.status.CARD_STATUS_CHECK';

export type CardStatusCheckAction = {
	type: typeof CARD_STATUS_CHECK;
	payload: ChangeEvent;
};

export const cardStatusCheck = (payload: ChangeEvent): CardStatusCheckAction => ({
	type: CARD_STATUS_CHECK,
	payload,
});

export type Action = CardStatusSetAction | CardStatusCheckAction;
